
import { useState, useEffect, useCallback } from 'react';
import { getMedicalRecords, deleteMedicalRecord } from '../services/medicalService';

export interface MedicalRecord {
  id: string;
  pet_id: string;
  user_id: string;
  title: string;
  record_type: string;
  record_date: string;
  description: string | null;
  vet_name: string | null;
  has_attachments: boolean | null;
  created_at: string;
  updated_at: string;
  attachments?: string[];
}

export const useMedicalRecords = (petId: string | undefined) => {
  const [records, setRecords] = useState<MedicalRecord[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!petId) {
      setIsLoading(false);
      return;
    }

    const fetchRecords = async () => {
      try {
        setIsLoading(true);
        const data = await getMedicalRecords(petId);
        setRecords(data);
      } catch (err: any) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRecords();
  }, [petId]);

  const refreshRecords = useCallback(async () => {
    if (!petId) return;
    try {
      setIsLoading(true);
      const data = await getMedicalRecords(petId);
      setRecords(data);
    } catch (err: any) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [petId]);

  const deleteRecord = useCallback(async (recordId: string) => {
    await deleteMedicalRecord(recordId);
    await refreshRecords();
  }, [refreshRecords]);

  return { records, isLoading, error, refreshRecords, deleteRecord };
};
